/**
 * ============================================================================
 * DEMAND CATEGORY CHECKBOXES — QuickSight-parity control row (spec R10).
 * ============================================================================
 *
 * The CTS QuickSight Executive Summary has a checkbox row selecting which
 * DEMAND_CATEGORIES section groups are visible. This is our equivalent for the
 * Detailed Summary tab: "All Networks" (the cross-network section group, spec
 * all-networks-section-group) + the seven registry entries. Terminology
 * matches the existing dashboard.
 *
 * Toggling recomputes client-side only (sections derive from the cached
 * rowset) — never a refetch. Selection persists via the dashboard slice.
 */

import React from 'react';
import Checkbox from '@amzn/awsui-components-core/checkbox';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import Box from '@amzn/awsui-components-core/box';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import { demandCategoryToggled, allNetworksToggled } from 'src/features/dashboard/dashboardSlice';
import {
  DEMAND_CATEGORY_IDS,
  DEMAND_CATEGORY_DISPLAY_NAMES,
  demandCategoryDisplayName,
} from 'src/config/demandCategories';

export const DemandCategoryCheckboxes: React.FC = () => {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.dashboard.selectedDemandCategories);
  const showAllNetworks = useAppSelector((state) => state.dashboard.showAllNetworks);

  return (
    <Box padding={{ vertical: 'xs' }}>
      <SpaceBetween direction="horizontal" size="l">
        {/* The cross-network section group (spec all-networks-section-group
            R3.1) — same three tables as every network, aggregated across all. */}
        <Checkbox
          checked={showAllNetworks}
          onChange={({ detail }) => dispatch(allNetworksToggled(detail.checked))}
        >
          {demandCategoryDisplayName('all')}
        </Checkbox>
        {DEMAND_CATEGORY_IDS.map((id) => (
          <Checkbox
            key={id}
            checked={selected.includes(id)}
            onChange={() => dispatch(demandCategoryToggled(id))}
          >
            {DEMAND_CATEGORY_DISPLAY_NAMES[id]}
          </Checkbox>
        ))}
      </SpaceBetween>
    </Box>
  );
};
